import { Injectable } from '@angular/core';
import { FullCustomDimensionsSet } from './full-custom-dimensions-set';
import { DataLayerCustomDimensions } from './data-layer-custom-dimensions';

// This is a type that can be used for a partial version of the dimensions set,
// Where there are gaps and some dimensions are empty
export type PartialCustomDimensionsSet = { [key: string]: string };

@Injectable()
export class DataLayerCustomDimensionsService {
  private _currentSet: FullCustomDimensionsSet;
  _constantDimensions;
  constructor() {
    this._generateEmptyDimensionsSet();
    this._constantDimensions = [];
  }

  set dimensions(someDimensions: PartialCustomDimensionsSet) {
    Object.keys(DataLayerCustomDimensions)
      .map((key) => DataLayerCustomDimensions[key])
      .forEach((key) => {
        this._currentSet[key] =
          someDimensions[key] || this._constantDimensions[key];
      });
  }

  trigger() {
    (<any>window).dataLayer.push(this._currentSet);
  }

  private _generateEmptyDimensionsSet() {
    this._currentSet = {
      [DataLayerCustomDimensions.Location]: undefined,
      [DataLayerCustomDimensions.event]: undefined,
      [DataLayerCustomDimensions.eventAction]: undefined,
      [DataLayerCustomDimensions.eventCategory]: undefined,
      [DataLayerCustomDimensions.eventLabels]: undefined,
    };
  }
}
